import React, { useEffect } from 'react';
import { bool, func, string } from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { QuickViewDrawer } from './sub-components/quick-view-drawer/QuickViewDrawer';
import { dataModel } from './dataModel';
import './QuickView.scss';

export const QuickView = ({
  isOpen,
  onClose,
  itemId,
  fetch
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('quick-view.ready'); }, []);

  const storeId = useStoreId();
  const { data } = useDataModel('product', {
    variables: {
      itemId,
      storeId
    },
    ssr: false,
    skip: !itemId || !fetch
  });
  if (!data?.product?.itemId) {
    // Console the error to track it
    return null;
  }

  return (
    <div className="quick-view">
      <QuickViewDrawer
        isOpen={isOpen}
        onClose={onClose}
        product={data?.product}
      />
    </div>
  );
};

QuickView.dataModel = dataModel;

QuickView.displayName = 'QuickView';

QuickView.propTypes = {
  isOpen: bool.isRequired,
  onClose: func,
  itemId: string.isRequired,
  fetch: bool
};

QuickView.defaultProps = {
  onClose: () => {},
  fetch: true
};
